module.exports = __webpack_public_path__ + "img/164w.7bcb357.jpg";